<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);

export default {
  name: 'GraficoCombinado',
  components: { Bar },
  props: {
    dados: {
      type: Array,
      required: true,
    },
    chartId: {
      type: String,
      default: 'grafico-combinado',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const labels = this.dados.map(d => d.treinador);

    const presencas = this.dados.map(d => d.presencas);
    const faltas = this.dados.map(d => d.faltas);
    const recuperadas = this.dados.map(d => d.recuperadas);
    const aulasPrevistas = this.dados.map(d => d.aulas_previstas);
    const aulasTotais = this.dados.map(d => d.total_aulas);
    this.alunosAtivos = this.dados.map(d => d.total_alunos_ativos);

    return {
      chartData: {
        labels,
        datasets: [
          {
            type: 'bar',
            label: 'Presenças',
            backgroundColor: '#4caf50',
            data: presencas,
          },
          {
            type: 'bar',
            label: 'Faltas',
            backgroundColor: '#f44336',
            data: faltas,
          },
          {
            type: 'bar',
            label: 'Recuperadas',
            backgroundColor: '#2196f3',
            data: recuperadas,
          },
          {
            type: 'line',
            label: 'Aulas Previstas',
            borderColor: '#ff9800',
            backgroundColor: '#ff9800',
            data: aulasPrevistas,
            tension: 0.3,
            fill: false,
            yAxisID: 'y',
          },
          {
            type: 'line',
            label: 'Aulas Totais',
            borderColor: '#9c27b0',
            backgroundColor: '#9c27b0',
            data: aulasTotais,
            tension: 0.3,
            fill: false,
            yAxisID: 'y',
          },
        ],
      },
      chartOptions: {
        responsive: true,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        stacked: false,
        scales: {
          y: {
            type: 'linear',
            position: 'left',
            title: {
              display: true,
              text: 'Quantidade de Aulas',
            },
          },
        },
        plugins: {
          title: {
            display: this.dados.length === 1,
            text: this.dados.length === 1 ? `Resumo do Treinador ${this.dados[0].treinador}` : '',
            font: {
              size: 18,
            },
            padding: {
              top: 10,
              bottom: 20,
            },
          },
          tooltip: {
            callbacks: {
              afterBody: context => {
                const index = context[0].dataIndex;
                const totalAlunos = this.alunosAtivos[index];
                return `Alunos ativos: ${totalAlunos}`;
              },
            },
          },
        },
      },
    };
  },
};
</script>
